import React from "react";
// UI Framework
import { TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TimelineIcon from "@mui/icons-material/Timeline";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { Modal, Button } from "src/Components";
// Local Components
import CreateAccountTable from "./CreateAccountTable";
import MwrAnnualChart from "./MwrAnnualChart";
import MwrPeriodChart from "./MwrPeriodChart";
import NavChart from "./NavChart";
import PeriodProfitLoss from "./PeriodProfitLoss";
// Services
import { getInvestmentTable } from "src/Requests/imePortfolio";
// Types
import {
  IInvestmentReturnSearchParams,
  IInvestmentReturnTableReport,
} from "src/Interfaces/imePortfolio";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import PortfoTableSection from "./PortfoTableSection";

interface IProps {
  searchParams: IInvestmentReturnSearchParams;
  refreshFlag: boolean;
  setRefresh: (flag: boolean) => void;
  totalRefreshFlag: boolean;
}

enum ModalMode {
  Period,
  Annual,
  Nav,
  period,
  Closed,
}

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return <TableCell />;
};

const AdditionalCol: React.FC<{
  row: IInvestmentReturnTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [modalMode, setModalMode] = React.useState<number>(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Period:
        return <MwrPeriodChart row={row} />;
      case ModalMode.Annual:
        return <MwrAnnualChart row={row} />;
      case ModalMode.Nav:
        return <NavChart row={row} />;
      case ModalMode.period:
        return <PeriodProfitLoss row={row} />;
    }
  };
  return (
    <TableCell>
      {modalMode !== ModalMode.Closed ? (
        <Modal
          title={modalMode === ModalMode.Period ? "نمودار بازده دوره‌ای" : modalMode === ModalMode.Annual ? "نمودار بازده سالانه" : modalMode === ModalMode.Nav ? "نمودار NAV" : "سود و زیان دوره‌ای"}
          UI={getModalUI()}
          onClose={() => setModalMode(ModalMode.Closed)}
          fullScreen
        />
      ) : null}
      {row.id === 7 || row.id === 8 || row.id === 3 || row.id === 5 ? (
        <Button
          text={
            <>
              <TimelineIcon style={{ fontSize: 16, marginLeft: 4 }} />
            </>
          }
          onClick={() => {
            setModalMode(
              row.id === 7
                ? ModalMode.Period
                : row.id === 3
                  ? ModalMode.Nav
                  : row.id === 5
                    ? ModalMode.period
                    : ModalMode.Annual,
            );
          }}
          variant="contained"
          className="table-btn"
        />
      ) : null}
    </TableCell>
  );
};

const Additional: IAdditional<IInvestmentReturnTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};

const InvestmentTable = ({
  searchParams,
  refreshFlag,
  setRefresh,
  totalRefreshFlag,
}: IProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  return (
    <PortfoTableSection
      title="محاسبه بازده"
      action={
        <EditIcon
          className={`${searchParams.userId ? "text-sky-700 cursor-pointer" : "text-gray-500 cursor-not-allowed"}`}
          onClick={() => {
            if (!searchParams.userId) return;
            setIsModalOpen(true);
          }}
        />
      }
    >
      {isModalOpen ? (
        <Modal
          title="حساب‌های محاسبه بازده"
          UI={
            <CreateAccountTable
              searchParams={searchParams}
              setRefresh={setRefresh}
              onClose={() => setIsModalOpen(false)}
            />
          }
          onClose={() => setIsModalOpen(false)}
          modalBoxClassName="!min-w-[0px] !h-[400px]"
        />
      ) : null}
      <TableTemplate<
        IInvestmentReturnSearchParams,
        IInvestmentReturnTableReport
      >
        getDataTable={getInvestmentTable}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={refreshFlag || totalRefreshFlag}
            AdditionalBody={Additional}
          />
        )}
        withSort
        searchParameters={searchParams}
      />
    </PortfoTableSection>
  );
};

export default InvestmentTable;
